import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { setDashboardFilters, resetDashboardState } from '_redux/modules/dashboard'
import { DASHBOARD_TIME_RANGE } from '../../../utils/constant'

export const defaultFilters = {
  time: DASHBOARD_TIME_RANGE.THIS_WEEK,
  status: null,
  eid: null,
  start: moment().subtract(7, 'days').startOf('day').unix(),
  end: moment().endOf('day').unix(),
}

const useDashboardFilters = (groupId) => {
  const dispatch = useDispatch()
  const reduxFilters = useSelector((state) => state.dashBoard.filters)
  const cachedGroupId = useSelector((state) => state.dashBoard.cachedGroupId)

  useEffect(() => {
    if (groupId && groupId !== cachedGroupId) {
      dispatch(resetDashboardState())
    }
  }, [groupId, cachedGroupId, dispatch])

  const filters = reduxFilters && groupId === cachedGroupId ? reduxFilters : defaultFilters

  const updateFilter = useCallback((keyOrObject, value) => {
    let next
    if (typeof keyOrObject === 'object' && keyOrObject !== null) {
      next = {
        ...filters,
        ...keyOrObject,
      }
    } else {
      next = {
        ...filters,
        [keyOrObject]: value,
      }
    }
    dispatch(setDashboardFilters(next, groupId))
  }, [dispatch, filters, groupId])

  const resetFilters = useCallback(() => {
    dispatch(resetDashboardState())
  }, [dispatch])

  return {
    filters,
    updateFilter,
    resetFilters,
  }
}

export default useDashboardFilters
